// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-9c1957fc],h4[data-v-9c1957fc]{--tw-text-opacity:1;color:#272729;margin-bottom:1.5rem}@supports (color:rgb(0 0 0/0)){h1[data-v-9c1957fc],h4[data-v-9c1957fc]{color:rgb(39 39 41/var(--tw-text-opacity))}}h1[data-v-9c1957fc]{margin-bottom:2.5rem}p[data-v-9c1957fc]{line-height:1.25;margin-bottom:3rem;white-space:pre-wrap}.container[data-v-9c1957fc]{max-width:1200px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
